import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Brochure from "../Brochure/Brochure.pdf";
import axiosInstance from "../Help/AxiosLogicInstance";
import { HashLink } from "react-router-hash-link";
import LazyImg from "./LazyImg";

const Footer = () => {
  const location = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [subscribing, setSubscribing] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setSubscribing(true);
    try {
      const res = await axiosInstance.post("/api/Student/Subscribe", {
        Email: email,
      });
      if (res.data.Status === "200") {
        alert("Subscribed successfully!");
        setEmail("");
      } else {
        alert(res.data.Message || "Subscription failed.");
      }
    } catch (err) {
      if (err.response?.data?.Message) {
        alert(err.response.data.Message);
      } else {
        alert("An error occurred. Please try again.");
      }
    }
    setSubscribing(false);
  };
  const handleScroll = (e, id) => {
    if (location.pathname === "/") {
      e.preventDefault();
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ detect scroll to show button
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <footer className="ul-footer" id="footer">
      {/* --- Content Section --- */}
      <div className="content-section">
        <div className="container">
          <div className="content-text">
            <p className="thumb-p text-center text-dark">
              Giving back to society is embedded in the value system of
              Metropolis Health Care Limited. We believe in and aim to bring
              about a positive change through our CSR efforts. In CSR
              initiatives, we partner with societies, educational institutions,
              government bodies, NGOs, wellness foundations, and a host of other
              organizations to make a difference to the lives we touch.
            </p>
            <p className="thumb-p text-center text-dark mt-3">
              MedEngage activities are undertaken under Schedule VII of the
              Companies Act, 2013, within the areas of promoting healthcare, including preventive
              healthcare, and promoting education.
            </p>
          </div>
        </div>
      </div>
      {/* --- Top Subscription --- */}
      <div className="ul-footer-top" id="subscribe">
        {" "}
        <div className="ul-footer-container">
          {" "}
          <div className="ul-footer-top-contact-infos">
            {" "}
            <div className="ul-footer-top-contact-info">
              {" "}
              <div className="uul-footer-top-contact-info-txt text-center text-lg-start">
                {" "}
                <h5>Stay updated on scholarships and news</h5>{" "}
                <p className="text-light">
                  Enter your email to hear when applications open.
                </p>{" "}
              </div>{" "}
            </div>{" "}
            <div className="subscription-form-container">
              {" "}
              <form
                className="subscription-form d-flex flex-wrap gap-2"
                onSubmit={handleSubscribe}
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  required
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={subscribing}
                />
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={subscribing}
                >
                  {subscribing ? "Subscribing..." : "Subscribe"}
                </button>
              </form>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>
      {/* --- Middle Nav --- */}
      <div className="ul-footer-middle py-4">
        <div className="container">
          <div className="row align-items-center text-center text-lg-start">
            {/* Left: Metropolis Logo */}
            <div className="col-12 col-lg-3 mb-3 mb-lg-0 d-flex flex-column align-items-center align-items-lg-start">
              <LazyImg
                src="/assets/img/Final-Logo_280624_white-01 1.png"
                alt="Metropolis Foundation logo"
                className="img-fluid mb-2"
                loading="lazy"
                width={200}
                height={60}
              />
              <p className="metropolis-logo-text mb-0 text-light fs-12 text-center text-lg-start">
                Metropolis Foundation
                <br /> CSR arm of Metropolis Healthcare Limited
              </p>
            </div>

            {/* Middle: MedEngage Logo + Navigation */}
            <div className="col-12 col-lg-6 mb-3 mb-lg-0 d-flex flex-column align-items-center">
              <LazyImg
                src="/assets/img/Medengage-whiteLogo-3 1.png"
                alt="MedEngage logo"
                className="img-fluid mb-2"
                loading="lazy"
                width={180}
                height={40}
              />

              <nav className="main-nav d-flex flex-wrap flex-lg-nowrap justify-content-center gap-3 w-100">
                <Link to="/" className="text-light">
                  Home
                </Link>

                <HashLink
                  smooth
                  to="/#about"
                  onClick={() => setIsOpen(false)}
                  scroll={(el) => {
                    const yOffset = -80; // adjust to your fixed header height
                    const y =
                      el.getBoundingClientRect().top +
                      window.pageYOffset +
                      yOffset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                  }}
                  className="text-light"
                >
                  <span className="fw-medium">About Us</span>
                </HashLink>

                <HashLink
                  smooth
                  to="/#programs"
                  scroll={(el) => {
                    const yOffset = -80; // adjust to your fixed header height
                    const y =
                      el.getBoundingClientRect().top +
                      window.pageYOffset +
                      yOffset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                  }}
                  onClick={() => setIsOpen(false)}
                  className="text-light"
                >
                  <span className="fw-medium">Programs</span>
                </HashLink>
                <Link to="/testimonials" className="text-light">
                  Testimonials
                </Link>
                <Link to="/stories" className="text-light">
                  Stories
                </Link>
                <Link
                  to={Brochure}
                  className="text-light"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Brochure
                </Link>
              </nav>
            </div>

            {/* Right: Social Media */}
            <div className="col-12 col-lg-3 d-flex flex-column align-items-center align-items-lg-end">
              <span className="d-block mb-2">Follow Us</span>
              <div className="social-icons d-flex gap-2">
                <a
                  href="https://www.facebook.com/metromedengage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyImg
                    src="/assets/img/facebook.png"
                    alt="Facebook — Metropolis MedEngage"
                    className="img-fluid"
                    loading="lazy"
                    width={32}
                    height={32}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/medengage/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyImg
                    src="/assets/img/linkedin.png"
                    alt="LinkedIn — Metropolis MedEngage"
                    className="img-fluid"
                    loading="lazy"
                    width={32}
                    height={32}
                  />
                </a>
                <a
                  href="https://x.com/metromedengage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyImg
                    src="/assets/img/twitter.png"
                    alt="X / Twitter — Metropolis MedEngage"
                    className="img-fluid"
                    loading="lazy"
                    width={32}
                    height={32}
                  />
                </a>
                <a
                  href="https://www.instagram.com/metromedengage/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyImg
                    src="/assets/img/instagram.png"
                    alt="Instagram — Metropolis MedEngage"
                    className="img-fluid"
                    loading="lazy"
                    width={32}
                    height={32}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Bottom Footer --- */}
      <div className="ul-footer-bottom py-3">
        <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center text-lg-start">
          <p className="mb-2 mb-lg-0 fs-6 text-muted">
            &copy; 2026 Metropolis Healthcare Limited. All Rights Reserved.
          </p>
          <div className="d-flex flex-column flex-sm-row gap-2">
            <a
              href="/privacy-policy.pdf"
              className="text-success"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href="mailto:support@med-engage.com"
              className="text-success"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@med-engage.com
            </a>
          </div>
        </div>
      </div>
      {/* ✅ Back to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="shadow position-fixed bottom-0 end-0 m-4 scroll-btn"
        >
          <i className="fa fa-arrow-up text-light"></i>
        </button>
      )}
    </footer>
  );
};

export default Footer;
